import EmojiObjectsRoundedIcon from "@mui/icons-material/EmojiObjectsRounded";
import { Box, Stack, Typography } from "@mui/material";

const CountClicks = () => {
  return (
    <>
      <Box
        sx={{
          border: "1px solid #0288D180",
          borderRadius: "8px",
          backgroundColor: "#0288D10A",
          p: 1,
          mb: 1,
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1} mb={1}>
          <EmojiObjectsRoundedIcon
            sx={{
              color: "#01579B",
              fontSize: 18,
            }}
          />

          <Typography
            sx={{
              color: "#01579B",
              fontSize: "14px",
              fontWeight: 500,
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
          >
            How we count clicks
          </Typography>
        </Stack>

        <Typography
          sx={{
            color: "#01579B",
            fontSize: "14px",
            lineHeight: "20px",
          }}
        >
          Clicks are <strong> not collected from the affiliate partner</strong>.
          They come from our own website tracking, stored in{" "}
          <strong> raw_website_clicks_in_out</strong>. Each row in this table
          represents one user click-out event — identified by its own id and
          timestamped in <strong>clickin_timestemp_utc</strong>.
          <p style={{ marginBottom: "0px" }}>
            {" "}
            Clicks are matched to this brand via
            <strong>
              &nbsp;link_name  →  raw_brand_links_wp.link_name  →  brand_id
            </strong>
            . Grouped by date_of_acquisition (day-level). Organic traffic with
            no reported link is excluded.
          </p>
        </Typography>
      </Box>
    </>
  );
};

export default CountClicks;
